<stx-org-tree-filter [formGroupReference]="formGroupReference" [orgTreeFilters]="orgTreeFilterData"></stx-org-tree-filter>
